export default function Version() {
    return (
        <>
           <p className="copyright">&copy; 2026 Albany School. Todos los derechos reservados. v1.0</p>
        </>
    )
}
